import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from "@angular/core";

import { PriceFormat, SHORT } from "@hermes/aphrodite/price";

import { VtoProduct } from "@hermes/api-model-vto";
import { DOWN, LEFT, RIGHT, UP } from "@hermes/utils-generic/constants";
import { ImageUrlPipe } from "@hermes/utils-generic/pipes/image-url";

const IMAGE_SIZE: number = 64;

@Component({
    selector: "h-virtual-try-on-variant-item",
    templateUrl: "./virtual-try-on-variant-item.component.html",
    styleUrls: ["./virtual-try-on-variant-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VirtualTryOnVariantItemComponent {
    @ViewChild("clickZone")
    public clickZone!: ElementRef;

    @Input()
    public index!: number;

    @Input()
    public product!: VtoProduct;

    @Input()
    public selected: boolean = false;

    @Input()
    public titleAlignment: "CENTER" | "LEFT" | "RIGHT" = "CENTER";

    @Input()
    public isDesktop = true;

    @Output()
    public selectItemSku: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    public focusItemIndex: EventEmitter<number> = new EventEmitter<number>();

    @Output()
    public slidePrev: EventEmitter<number> = new EventEmitter<number>();

    @Output()
    public slideNext: EventEmitter<number> = new EventEmitter<number>();

    public formatCurrency: PriceFormat = SHORT;

    public isBreakImage: boolean = false;

    constructor(private imageUrlPipe: ImageUrlPipe) {}

    /**
     * Generate the scene7 url
     *
     * @param url : url of image
     */
    public getScene7Url(url: string): string {
        return this.imageUrlPipe.transform(url, {
            width: IMAGE_SIZE,
            height: IMAGE_SIZE,
            sourceSet: false,
            resmode: "sharp",
            quality: "100",
        });
    }

    public clickVariant(sku: string): void {
        // on mobile we emit after a slider transition
        if (this.isDesktop) {
            this.selectItemSku.emit(sku);
        }
    }

    public keydownVariant(event: KeyboardEvent, index: number): void {
        if (this.isDesktop) {
            if ([LEFT, UP].includes(event.key)) {
                this.focusItemIndex.emit(index - 1);
            } else if ([RIGHT, DOWN].includes(event.key)) {
                this.focusItemIndex.emit(index + 1);
            }
        } else {
            if ([LEFT, UP].includes(event.key)) {
                this.slidePrev.emit(index);
            } else if ([RIGHT, DOWN].includes(event.key)) {
                this.slideNext.emit(index);
            }
        }
    }

    public handleErrorImage(): void {
        this.isBreakImage = true;
    }
}
